function ltrIslandProps(width = "fit-content") {
  return {
    dir: "ltr",
    style: { width, maxWidth: "100%" }
  };
}
export {
  ltrIslandProps as l
};
